<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.ofiRegisteredAccounts.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.ofiRegisteredAccounts.NOW_YOU_CAN"></p>
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.ofiRegisteredAccounts.DESCRIPTION"></p>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           src="ofi-registered-accounts.svg"
           [attr.alt]="'tdWb.modalNotification.ofiRegisteredAccounts.IMAGE_ALT' | translate"
           aria-hidden="true"
           class="td-wb-modal-notification--image-small"
      />
    </div>
  </div>
</div>